<template>
    <div class="wl-container">
        <div class="wl-img-list">
            <ul v-loading="loading" class="wl-clear-float" :style="{ backgroundColor: pagination.total >= 1 ? '' : '#ffffff' }">
                <li v-for="(item, index) in data" :key="item.id" :class="(index + 1) % 4 === 0 ? 'noMarginR' : ''">
                    <a :href="item.insightUrl" @click.prevent="navTo(item.insightUrl)">
                        <div
                            v-if="item.imageByte"
                            class="imageItem"
                            :style="`background-image: url( data:image/png;base64,${item.imageByte});
                    background-size: auto 100%;
                    background-repeat: no-repeat;
                    background-position: center;
                 `"
                        ></div>
                        <div v-else class="imageItem bg-img"></div>
                    </a>

                    <span class="show-overflow-tooltip insightTitle" :title="item.insightTitle">{{ item.insightTitle }} </span>
                </li>
                <div v-if="pagination.total <= 0" class="el-table__empty-block" style="height: 300px">
                    <p class="el-table__empty-text">{{ $t('INSIGHTS_NO_DATA') }}</p>
                </div>
                <el-pagination
                    class="wl-pagination"
                    :current-page="pagination.current"
                    :page-size="pagination.pageSize"
                    @current-change="onCurrentPageChange"
                    layout="prev, pager, next,total"
                    :total="pagination.total"
                ></el-pagination>
            </ul>
        </div>
    </div>
</template>

<script>
import API from '@/api'
import MImage from './image'
import { mapGetters } from 'vuex'

export default {
    name: 'insights',
    mounted() {
        this.queryInsightsList()
    },
    data() {
        return {
            loading: false,
            data: [],
            pagination: {
                current: 1,
                pageSize: 12,
                total: 0
            }
        }
    },
    methods: {
        navTo(url) {
            window.open(url)
        },
        queryInsightsList: async function () {
            const d = new Date()
            const storageKey = `${d.getFullYear()}_${d.getMonth()}_${d.getDate()}_${this.getUser.userAccount}_${this.getSite.siteId}_${
                this.pagination.current
            }_${this.pagination.pageSize}`
            this.loading = !this.loading
            const dataFromStorage = localStorage.getItem(storageKey)
            if (dataFromStorage !== null) {
                const data = JSON.parse(dataFromStorage)
                this.data = data.records
                this.pagination.total = data.total
                this.loading = !this.loading
            } else {
                try {
                    const { code, success, data, errDetails } = await API.insights.selectInsight({
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize,
                        siteId: this.getSite.siteId
                    })
                    if (code == '1') {
                        try {
                            localStorage.setItem(storageKey, JSON.stringify(data))
                        } catch (e) {
                            console.error('想要缓存，但是没缓存进去')
                            console.error(e)
                        }

                        this.data = data.records
                        this.pagination.total = data.total
                    } else {
                        this.$message.error(this.$t(code))
                    }
                } catch (e) {
                    console.error(e)
                } finally {
                    this.loading = !this.loading
                }
            }
        },
        onCurrentPageChange(current) {
            this.pagination.current = current
            this.queryInsightsList()
        }
    },
    computed: {
        ...mapGetters('common', {
            getSite: 'getSite',
            getUser: 'getUser',
            getCollapse: 'getCollapse'
        })
    },
    watch: {
        $route: {
            handler(route) {},
            deep: true,
            immediate: true
        }
    },
    components: {
        MImage
    }
}
</script>

<style scoped>
.wl-clear-float {
    zoom: 1;
    min-height: 350px;
    position: relative;
}

.wl-clear-float li {
    width: 23%;
    border-radius: 8px;
    border: 1px solid #fff;
}

.wl-clear-float:after {
    content: '';
    clear: both;
    display: block;
    height: 0;
    width: 0;
    overflow: auto;
}

.wl-container {
    background: #eff1f5;
    height: 100%;
    width: 100%;
    color: #444;
    font-size: 14px;
    padding: 22px;
}

.wl-img-list {
    height: 100%;
}

.wl-img-list ul li {
    float: left;
    background: #fff;
    padding: 12px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 0 2.6% 20px 0;
    cursor: pointer;
}

.wl-img-list ul li span {
    display: inline-block;
    margin-top: 12px;
    line-height: 22px;
    max-height: 48px;
    overflow: hidden;
    font-size: 20px;
}

.wl-pagination {
    position: absolute;
    bottom: -35px;
    width: 100%;
    background-color: rgba(255, 255, 255, 0);
}
.wl-pagination.el-pagination ::v-deep .number {
    background-color: #fff !important;
    margin-right: 5px;
}

.wl-m-loading {
    background: rgba(255, 255, 255, 0.9);
}

.imageItem {
    display: block;
    width: 100%;
    height: 100%;
}

.bg-img {
    background-image: url('~@/assets/img/insights.jpg');
    background-size: 100% 100%;
}

ul a {
    display: inline-block;
    width: 100%;
    height: 17vh;
}

.show-overflow-tooltip {
    display: inline-block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.noMarginR {
    margin-right: 0px !important;
}
.wl-clear-float li:hover {
    border: 1px solid #3879eb;
    box-shadow: 0 0 15px rgba(56, 121, 235, 0.2);
}
.wl-clear-float li:hover .show-overflow-tooltip {
    color: #3879eb;
}
.insightTitle {
    text-align: center;
}
</style>
